import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppInfoService } from '@shared/services/common/app-info.service';
import { AnswerGroupModel, AnswerModel, ConnectionModel, IceCandidateModel, IceGroupCandidateModel, OfferGroupModel, OfferModel } from '../../models/call-users-model';
import { UserVm } from '../../models/userVm';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    onUsersChanged: BehaviorSubject<any>;
    onlineUsersSubject: BehaviorSubject<string[]>

    users: [];
    onlineUsers: string[] = [];
    constructor(public appInfo: AppInfoService, private http: HttpClient) {
        this.onUsersChanged = new BehaviorSubject([]);
        this.onlineUsersSubject = new BehaviorSubject([]);
    }
    GetUserWPhoto(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(this.appInfo.appUrl + "api/user/getuserwphoto", this.appInfo.httpOptions).subscribe(data => {
                this.users = data;
                this.onUsersChanged.next(data);
                resolve(data)
            }, reject)
        })
    }
    GetUser(userId): Observable<any> {
        return this.http.get<any>(this.appInfo.appUrl + "api/user/getuserbyid?userId=" + userId, this.appInfo.httpOptions);
    }
    getAllUsers() {
        return this.http.get<any>(this.appInfo.appUrl + "api/user/getallusers", this.appInfo.httpOptions);

    }

    getAllUsersVM(): Observable<UserVm[]> {
      return this.http.get<UserVm[]>(this.appInfo.appUrl + "api/user/getallusersvm", this.appInfo.httpOptions);
    }

    addUser(user: UserVm): Observable<number> {
      return this.http.post<number>(`${this.appInfo.appUrl}api/user/adduser`, user, this.appInfo.httpOptions);
    }

    updateUser(user: UserVm): Observable<string> {
      return this.http.post<string>(`${this.appInfo.appUrl}api/user/updateuser`, user, this.appInfo.httpOptions);
    }

    getAllGroups(): Observable<any[]> {
      return this.http.get<any[]>(this.appInfo.appUrl + "api/user/getAllUsersGroups", this.appInfo.httpOptions);
    }

    addGroup(userGroupForm: any): Observable<any> {
      return this.http.post<number>(`${this.appInfo.appUrl}api/user/addgroup`, userGroupForm, this.appInfo.httpOptions);
    }

    updateGroup(userGroupForm: any): Observable<any> {
      return this.http.post<string>(`${this.appInfo.appUrl}api/user/updategroup`, userGroupForm, this.appInfo.httpOptions);
    }

    applyGroupPermissions(groupPermissionTasks: any[]): Observable<any> {
      return this.http.post<any>(`${this.appInfo.appUrl}api/management/applygroupPermissions`, groupPermissionTasks, this.appInfo.httpOptions);
    }

    HasAccessFlow(userId: number) {
        return this.http.get<any>(`${this.appInfo.appUrl}api/user/hasaccessflow?userId=${userId}`, this.appInfo.httpOptions);
    }
    getUserGroupIds(userId: number) {
        return this.http.get<any>(`${this.appInfo.appUrl}api/user/getusergroupids?userId=${userId}`, this.appInfo.httpOptions);
    }
    getPostList(selectedUser: number, userId: number) {
        return this.http.get(`${this.appInfo.appUrl}api/profile/getpostlist?selectedUser=${selectedUser}&userId=${userId}`, this.appInfo.httpOptions);
    }
    GetEmployeeList(userId): Observable<any> {
        return this.http.get<any>(this.appInfo.appUrl + "api/user/getemployeelist?userId=" + userId, this.appInfo.httpOptions);
    }    
    setUserActiveFormsNull(userId: number, formOrMenuData: number, formId: number, menuRowId: number, nodeKey: string) {
        return this.http.get(`${this.appInfo.appUrl}api/user/setuseractivetasksnull?userId=${userId}&formOrMenuData=${formOrMenuData}&formId=${formId}
        &menuRowId=${menuRowId}&nodeKey=${nodeKey}`, this.appInfo.httpOptions);
    }
    findSubordinates(userId: number, subordinates: any[] = []): any[] {
        const currentUser = this.appInfo.RiverEntity.users.find(user => user.id === userId);
        if (currentUser) {
            if (!!currentUser.managerId && currentUser.managerId > 0) {
                if (!subordinates.includes(currentUser.managerId)) {


                    subordinates.push(currentUser.managerId);
                    this.findSubordinates(currentUser.managerId, subordinates);
                }
            }
        }
        return subordinates;
    }

    checkButtonPassword(btnPassword: string, userId: number) {
        return this.http.get<any>(`${this.appInfo.appUrl}api/user/checkbuttonpassword?btnPassword=${btnPassword}&userId=${userId}`, this.appInfo.httpOptions);
    }

    getUserPhotoById(id: number) {
        return this.http.get(`${this.appInfo.appUrl}api/user/getuserphotobyid?id=${id}`, { responseType: 'text' });
    }
    getUserPhotosByIds(userIds: number[]): Observable<string> {
        return this.http.post<{data: string}>(
            `${this.appInfo.appUrl}api/user/getuserphotosbyids`, 
            userIds
        ).pipe(
            map(response => response.data)
        );
    }
    updateOnlineUsers(onlineUsers: any) {       
        const filteredUsers = this.appInfo.RiverEntity.users.filter(user =>
            onlineUsers.some(onlineUser => onlineUser.userId === user.id.toString())
        );
        this.onlineUsersSubject.next(filteredUsers);
    }
    GetUserList() {
        return this.http.get<any>(this.appInfo.appUrl + "api/user/getuserlist", this.appInfo.httpOptions);
    }
    updateUserList(users: any[]): Observable<any> {
        return this.http.post<any>(
            `${this.appInfo.appUrl}api/user/updateuserlist`,
            users,
            this.appInfo.httpOptions
        );
    }
    getGroups(): Observable<any[]> {
        return this.http.get<any[]>(`${this.appInfo.appUrl}api/user/getgroups`, this.appInfo.httpOptions);
    }
}
